import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { Message } from '@tv3/store/message/message.model'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import { MessageDetailsComponent } from './message-details.component'

@Injectable()
export class MessageDetailsDialogService {
  constructor(private dialog: MatDialog) {}

  open(data: any = { message: Message, inquiry: Inquiry }) {
    let defaultConfig: MatDialogConfig = {
      width: '600px',
      height: 'auto',
      panelClass: ['fixed-modal'],
      data: data,
    }

    return this.dialog.open(MessageDetailsComponent, defaultConfig)
  }
}
